import {delay} from "redux-saga";
import {put, select, takeEvery, call} from "redux-saga/effects";

import {AppNotificationMessage} from "../../domain/model/app_notification_message";

import {
    AppNotificationMessageActionType,
    createAppNotificationMessageActionCreator,
    IAppNotificationMessageActionCreator,
    IRequestAddAction,
    IRequestHiddenAction,
} from "../action/app_notification_message_action";
import {
    HiddenAppNotificationRequest,
} from "../request/app_notification_message_request";
import {
    AddAppNotificationResponse,
    HiddenAppNotificationResponse,
} from "../response/app_notification_message_response";
import {FrontDate} from "../../domain/model/frontDate";
import {AppState} from "../store/app_state";
import {AppNotificationMessageState} from "../store/app_notification_message_state";
import {frontEndConfig} from "../../config/config";

const actionCreator: IAppNotificationMessageActionCreator = createAppNotificationMessageActionCreator();

function* handleAddInAppNotificationMessage() {
    yield takeEvery(AppNotificationMessageActionType.REQUEST_ADD, execAddNotificationMessage)
}

function* execAddNotificationMessage(action: IRequestAddAction) {
    try {
        const item: AppNotificationMessage = AppNotificationMessage.from(
            AppNotificationMessage.createId(),
            action.item.type,
            action.item.message,
            FrontDate.fromNew(),
        );
        const res: AddAppNotificationResponse = new AddAppNotificationResponse();
        res.appNotificationMessage = item;
        yield put(actionCreator.callbackAddAction(true, res));

        // HiddenActionを遅延発行
        yield call(delay, frontEndConfig.delayTimeAppNotificationMessage);
        const notificationReq: HiddenAppNotificationRequest = new HiddenAppNotificationRequest();
        notificationReq.id = item.id;
        yield put(actionCreator.requestHiddenAction(notificationReq));

    } catch (error) {
        yield put(actionCreator.callbackAddAction(false));
    }

}

function* handleHiddenInAppNotificationMessage() {
    yield takeEvery(AppNotificationMessageActionType.REQUEST_HIDDEN, execHiddenNotificationMessage)
}

function* execHiddenNotificationMessage(action: IRequestHiddenAction) {
    try {
        // 現状のStateを取得し更新用のデータを作成する
        const selector = (state: AppState) => state.appNotificationMessageReducer;
        const _state: AppNotificationMessageState = yield select(selector);
        const items: AppNotificationMessage[] =
            _state.appNotificationMessages.map((item: AppNotificationMessage)=>{
                if (item.id === action.item.id) {
                    item.isHidden = true;
                    return item;
                } else {
                    return item;
                }
            });
        const res: HiddenAppNotificationResponse = new HiddenAppNotificationResponse();
        res.appNotificationMessages = items;
        yield put(actionCreator.callbackHiddenAction(true, res));
    } catch (error) {
        yield put(actionCreator.callbackHiddenAction(false));
    }

}

export {
    handleAddInAppNotificationMessage,
    handleHiddenInAppNotificationMessage,
};



// WEBPACK FOOTER //
// ./src/presentation/handler/app_notification_message_handler.ts